import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface AGUScaleOption { Value: number; Label: string; Description: readonly string[] }

/**
 * A rubric scale: one native radio per level, each row showing a bold label over a muted
 * description (OEP prototype markup.html:556/:711). Native radios give arrow-key navigation and
 * radiogroup semantics without custom key handling (UBP §4).
 */
@Component({
    standalone: false,
    selector: 'agu-scale-choice',
    templateUrl: './scale-choice.component.html',
    styleUrl: './scale-choice.component.scss',
})
export class AGUScaleChoiceComponent {
    @Input() Options: readonly AGUScaleOption[] = [];
    @Input() Value: number | null = null;
    /** Radio group name — must be unique on the page (e.g. the question ID). */
    @Input() Name = 'scale';
    @Input() Disabled = false;
    /** ID of the element holding the question text. */
    @Input() LabelledBy: string | null = null;
    /** A pick is required: conveyed to assistive tech as aria-required on the radiogroup. */
    @Input() Required = false;
    @Output() ValueChange = new EventEmitter<number>();

    IsSelected(o: AGUScaleOption): boolean { return o.Value === this.Value; }
    OptionID(i: number): string { return `${this.Name}-opt-${i}`; }
    Select(value: number): void {
        if (this.Disabled || value === this.Value) return;
        this.ValueChange.emit(value);
    }
}
